export default __webpack_public_path__ + "static/101-min-min-7268af34478385afa32b2ba2e5a72c40.jpg";